import { z } from 'zod';

/**
 * Account settings document (camelCase, end-to-end).
 *
 * A deliberate, documented exception to the snake_case-wire / camelCase-domain
 * seam: the settings document is camelCase in the wire, the DB blob, and the
 * domain, with NO mapper (see CONTEXT.md "Settings document casing"). This
 * schema therefore doubles as the domain type.
 *
 * Every field carries a `.default()`, so `.parse({})` yields a fully-populated
 * document and adding a setting needs no migration — a missing key resolves to
 * its default. This shape MUST stay identical to the gateway's
 * `AccountSettingsSchema` (flavrly-gateway-hono/src/schemas/user-settings.ts).
 */
export const AccountSettingsSchema = z.object({
  units: z.enum(['imperial', 'metric']).default('imperial'),
  defaultLandingScreen: z.enum(['discover', 'activity']).default('discover'),
  pushEnabled: z.boolean().default(true),
  emailEnabled: z.boolean().default(true),
  friendActivity: z.boolean().default(true),
  newFollowers: z.boolean().default(true),
  recommendations: z.boolean().default(true),
  reviewReminders: z.boolean().default(true),
  schemaVersion: z.number().default(1),
});

export type AccountSettings = z.infer<typeof AccountSettingsSchema>;
